import { matchPath } from "react-router";

import { ASSISTANT_ROUTE_CATALOG, type AssistantRouteCatalogEntry } from "@/lib/app-route-manifest";
import type { BrandAssistantCurrentPageContext } from "@/lib/brand-assistant-chat-request";

export const getBrandAssistantCurrentPageContext = ({
  brandId,
  pathname,
  routeCatalog = ASSISTANT_ROUTE_CATALOG,
}: {
  brandId: string | null | undefined;
  pathname: string;
  routeCatalog?: readonly AssistantRouteCatalogEntry[];
}): BrandAssistantCurrentPageContext | null => {
  if (!brandId) {
    return null;
  }

  for (const route of routeCatalog) {
    const match = matchPath({ path: route.pathTemplate, end: true }, pathname);
    if (!match) {
      continue;
    }

    const params = Object.fromEntries(
      Object.entries(match.params).flatMap(([key, value]) => {
        if (!value) {
          return [];
        }
        return [[key, value]];
      }),
    );

    if (params.brandId !== brandId) {
      continue;
    }

    return {
      routeId: route.id,
      label: route.label,
      description: route.description,
      href: pathname,
      pathTemplate: route.pathTemplate,
      params,
    };
  }

  return null;
};
